/**
 * @file 获取图片宽高
 * @param 传入的参数可以是单个url，也可以是对象数组，同时支持 File 对象
 * 1、https://www.xxxxxxx
 * 2、['https://www.xxxxxxx', 'https://www.xxxxxxx', ...]
 * 3、[{url: http, ...}, {url: http, ...}, ...]
 * 4、[{src: http, ...}, {src: http, ...}, ...]
 * 5、[File, File, ...]
 * */

let cache = {};

const mkPromise = function (image) {
    return new Promise(resolve => {
        let img = new Image();
        let result = {};
        if (typeof image === 'string') {
            if (cache[image]) {
                resolve(cache[image]);
            } else {
                img.onload = function () {
                    result = {
                        url: image,
                        width: this.width,
                        height: this.height
                    };
                    cache[image] = result;
                    resolve(result);
                };
                img.onerror = function (err) {
                    result = {
                        url: image,
                        error: err
                    };
                    // 这里统一采用resolve，方便在同一个回调中获取到正确或不正确的结果
                    resolve(result);
                };
                img.src = image;
                if (img.complete) {
                    result = {
                        url: image,
                        width: this.width,
                        height: this.height
                    };
                    cache[image] = result;
                    resolve(result);
                }
            }
        } else if (image instanceof File) {
            let reader = new FileReader();
            reader.onload = e => {
                let data = e.target.result;
                img.onload = () => {
                    result = Object.assign({}, image, {
                        width: img.width,
                        height: img.height
                    });
                    resolve(result);
                };
                img.onerror = err => {
                    result = Object.assign({}, image, {
                        error: err
                    });
                    resolve(result);
                };
                img.src = data;

            };
            reader.onerror = err => {
                result = Object.assign({}, image, {
                    error: err
                });
                // 这里统一采用resolve，方便在同一个回调中获取到正确或不正确的结果
                resolve(result);
            };
            reader.readAsDataURL(image);
        }
    });
};

export default function (images = []) {
    if (typeof images === 'string') {
        // 单张图片
        return mkPromise(images);
    }
    if (Array.isArray(images)) {
        // 多张图片
        let promises = images.map(item => mkPromise(item));
        return Promise.all(promises);
    }
}